import { isEmpty } from 'lodash-es'
import * as arrayUtils from './arrayUtils'

/**
判断路径是否是复杂对象。
 * @param {object} path 对象
 * @param {String} path 属性名
 * @return {boolean}

  path=“obj.valu1”  =>return true
*/
export const getArrayPath = function (path) {
  //	if(!obj)obj={};
  if (!path) return []
  // var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  return path.split('.')
}

/**
判断路径是否是复杂对象。
 * @param {object} path 对象
 * @param {String} path 属性名
 * @return {boolean}

  path=“obj.valu1”  =>return true
*/
export const isObjectOfPath = function (obj, path) {
  //	if(!obj)obj={};
  if (!path) return false
  // var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  var keyArr = path.split('.')
  return keyArr.length > 0
}

/**
获取第一级属性名
 * @param {object} path 对象
 * @param {String} path 属性名
 * @return {boolean}
path=“obj.valu1”  =>return “obj”
*/
export const getFirstPropertyOfPath = function (obj, path) {
  //	if(!obj)obj={};
  if (!path) return path
  // var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  var keyArr = path.split('.')
  return keyArr[0]
}

/**
深度设值：
obj={};
path="obj.code";
value="abc"

=>
return {
			obj{
			code:"abc"
		}
};
*/
export const setValueByPath = function (obj, path, value) {
  if (!obj) obj = {}
  var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')

  var keyArr = path.split('.')
  var len = keyArr.length

  for (var i = 0; i < len; ++i) {
    var key = keyArr[i]
    if (i == len - 1) {
      // if(value === undefined)
      tempObj[key] = value
      break
    }
    //解决tempObj[key]="string"
    if (!tempObj[key]) tempObj[key] = {}
    else if (!(typeof tempObj[key] === 'object')) tempObj[key] = {}
    tempObj = tempObj[key]
  }

  var fristProprtyData = obj[keyArr[0]]

  //返回第1级对象属性，用vue.$set 触发
  return fristProprtyData
}

/**
深度设值：
obj={};
path="obj.code";
value="abc"

=>
return {
			obj{
			code:"abc"
		}
};
*/

export const setValueByPathForVue = function (obj, path, value, vue) {
  //	if(!obj)obj={};
  var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')

  var keyArr = path.split('.')
  var len = keyArr.length

  for (var i = 0; i < len; ++i) {
    var key = keyArr[i]

    // export const setValueByPathForVue 只读属性不允许设值
    if (tempObj) {
      // 只读属性不允许设值
      if (Object.isFrozen(tempObj)) {
        // console.log("tempObj.isFrozen()", Object.isFrozen(tempObj), tempObj,
        //   path);
        return
      }
    }

    if (i == len - 1) {
      // if(value === undefined)
      vue.$set(tempObj, key, value)
      // tempObj[key] = value;
      break
    }
    // 解决tempObj[key]="string"

    // 非对象，导致报错。
    if (tempObj && typeof tempObj != 'object') {
      console.warn('not object warn:')
      return
    }
    if (!tempObj[key]) {
      vue.$set(tempObj, key, {})
    } else if (!(typeof tempObj[key] === 'object')) vue.$set(tempObj, key, {})
    tempObj = tempObj[key]
  }
}

/**
深度设值：
obj={
			obj:{
			code:"abc"
		};

path="obj.code"

=>
return "abc"
*/
export const getValueByPath = function (obj, path, defaultValue = null, isObj) {
  // if (path == 'order.source.depot.id') {
  // debugger;
  // }
  // console.log("export const getValueByPath", obj, path, defaultValue);

  if (!path) return obj // 支持path传空字符串返回obj的情况
  var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  var keyArr = path.split('.')
  var i = 0
  for (var len = keyArr.length; i < len - 1; ++i) {
    var key = keyArr[i]
    if (!tempObj) return defaultValue
    // 非对象，导致报错。
    if (typeof tempObj !== 'object') {
      return defaultValue
    }
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return defaultValue
    }
  }

  if (!tempObj) return defaultValue
  // export const getValueByPath 属性值不存在清空下，使用缺失值防止undefined
  if (!tempObj.hasOwnProperty(keyArr[i])) return defaultValue

  if (isObj) {
    return arrayUtils.getArrayLinkWithSeparator(tempObj[keyArr[i]], 'id', ',', '-1')
  } else {
    return tempObj[keyArr[i]]
  }
  // return {
  // o: tempObj,
  // k: keyArr[i],
  // v: tempObj[keyArr[i]]
  // };
}

/**
 * 获取对象对应key值（若不存在或为假则返回设置的默认值defaultValue）
 * @return {[type]} [description]
 */
export const getValueByPathNotNull = function (obj, path, defaultValue = null) {
  let tempValue = getValueByPath(obj, path, defaultValue)
  if (tempValue || tempValue === 0) {
    return tempValue
  } else {
    return defaultValue
  }
}

/**
 * 获取对象对应key值（若不存在或为假则返回设置的默认值defaultValue）
 * @return {[type]} [description]
 */
export const toJsonStringify = function (obj, defaultValue = null) {
  if (obj) {
    return JSON.stringify(obj)
  } else {
    return defaultValue
  }
}

/**
      删除属性
*/
export const deleteByPath = function (obj, path) {
  var tempObj = obj
  path = path.replace(/\[(\w+)\]/g, '.$1')
  path = path.replace(/^\./, '')
  var keyArr = path.split('.')
  var i = 0
  for (var len = keyArr.length; i < len - 1; ++i) {
    var key = keyArr[i]
    if (key in tempObj) {
      tempObj = tempObj[key]
    } else {
      return null
    }
  }
  if (tempObj && keyArr[i]) delete tempObj[keyArr[i]]
}

export const toJson = function (obj) {
  return JSON.stringify(obj)
}
/*
      深度拷贝
*/
export const clone = function (obj) {
  // Handle the 3 simple types, and null or undefined or function
  if (null === obj || 'object' !== typeof obj) return obj
  // Handle Date
  /* if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    } */
  // Handle Array or Object
  if (obj instanceof Object) {
    var copy = obj instanceof Array ? [] : {}
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = clone(obj[attr])
      }
    }
    return copy
  }
  throw new Error("Unable to clone obj! Its type isn't supported.")
}

/**
   （包含或判断）获取对象值，判断 在数组中包含任意数据则返回true
 * @param {object} path 对象
 * @param {String} path 属性名
 @param {array or string} containArray 数组 或字符串
 * @return {boolean}

 用法：export const containOrValueByPath(data,'status.code',['DRAFT','REJECT'])

模板表达式用法:
{{$imports.export const containOrValueByPath(data,'status.code',['DRAFT','REJECT'])}}

*/
export const containOrValueByPath = function (obj, path, containArray) {
  var objValue = getValueByPath(obj, path, null)
  if (!containArray) return true
  if (containArray instanceof Array) {
    for (var i = 0; i < containArray.length; i++) {
      if (containArray[i] == objValue)
        // 如果要求数据类型也一致，这里可使用恒等号===
        return true
    }

    return false
  } else {
    return containArray == objValue
  }
}

export const arrayToStr = function (arr, separator) {
  return arr.join(separator)
}

// 深度冻结对象
export const deepFreeze = function (obj) {
  if (typeof obj !== 'object') return obj
  Object.freeze(obj)
  for (let attr in obj) {
    if (obj.hasOwnProperty(attr)) {
      deepFreeze(obj[attr])
    }
  }
  return obj
}

// 查看对象类型
export const objType = function (obj) {
  if (obj === null) return null
  if (obj === undefined) return undefined
  return Object.prototype.toString.call(obj)
}
// 生成不重复的ID
export const createID = function () {
  const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  return `${S4()}-${S4()}-${S4()}-${S4()}`
}

//将传入的数组根据key转换为map
export const arrToMapByKey = function (arr, key) {
  let resMap = new Map()
  arr.forEach((item) => {
    let keyArr = resMap.get(item[key])
    if (keyArr) {
      keyArr.push(item)
    } else {
      resMap.set(item[key], [item])
    }
  })
  return resMap
}

//将两个数组根据k数组1的顺序进行合并，数组2中多余的项添加到数组1之后
export const arrMergeByKey = function (source, target, key) {
  if (!target || target.length === 0) return source
  let targetMap = new Map()
  let targetOtherMap = new Map()
  target.forEach((item, index) => {
    let keyVal = getValueByPath(item, key)
    keyVal ? targetMap.set(keyVal, item) : targetOtherMap.set(index, item)
  })
  source.forEach((item, index) => {
    let keyVal = getValueByPath(item, key)
    source[index] = targetMap.get(keyVal) || source[index]
    keyVal && targetMap.delete(keyVal)
  })
  if (targetMap.size > 0) {
    source.push(...targetMap.values())
  }
  if (targetOtherMap.size > 0) {
    source.push(...targetOtherMap.values())
  }
  return source
}

/**
 * 拼接字段的值，适用于需求#5444 地址信息的拼接
 * 格式：
 * data={
 *  receiveAddress: {
 *      district: {
 *          ...,
 *          name: '四川省成都市成华区'
 *      },
 *      address: '猛追湾街道20号',
 *  }
 * }
 * fields=['receiveAddress.district.name', 'receiveAddress.address']
 * separator=''
 *
 * 执行方法后
 *
 * 四川省成都市成华区猛追湾街道20号
 *
 * @param {object} data 取值的数据
 * @param {string[]} [fields=[]] 字段集 由字段取值的 code 组成的字符串数组
 * @param {string} [separator=''] 分隔符
 * @param {string} [noValueSymbol='-'] 当值不存在的时候用符号("-")代替
 */
export const strJoinBySeparator = function (
  data,
  fields = [],
  separator = '',
  noValueSymbol = '-'
) {
  console.log('export const strJoinBySeparator: ', data, typeof data)
  if (!data) throw new Error('请传入 data！')
  if (!(fields instanceof Array)) throw new Error('拼接的字段值的类型必须是 Array！')

  const result = fields.reduce((prev, path) => {
    const str = getValueByPath(data, path, '')
    if (str) prev.push(str)

    return prev
  }, [])

  // 无值
  if (!result.length) return noValueSymbol

  return result.join(separator)
}

/**
 * @name 升序排序
 */
export const asc = function (a, b, path = 'code') {
  const _a = getValueByPath(a, path)
  const _b = getValueByPath(b, path)

  if (_a < _b) return -1
  if (_a > _b) return 1

  return 0
}

/**
 * @name 降序排序
 */
export const desc = function (a, b, path = 'code') {
  const _a = getValueByPath(a, path)
  const _b = getValueByPath(b, path)

  if (_a < _b) return 1
  if (_a > _b) return -1

  return 0
}

/**
 * @name 转换模板数据
 *
 * @param {String} source 模板数据源
 * @param {String|RegExp} [target='ñ'] 替换的目标内容
 * @param {Any} [replacement=String.fromCharCode(29)] 替换值 @see https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/String/replace
 *
 * @description
 * 示例: 转换博思得打印二维码的数据
 * export const replace(010694371820203510202203141041ñ301ñ1122030117240229) -> 010694371820203510202203141041\x1D301\x1D1122030117240229
 *
 */
export const replace = function (source, target = /ñ/g, replacement = String.fromCharCode(29)) {
  if (isEmpty(source)) return source // 如果 source 为空则直接返回，等效为不处理
  return String.prototype.replace.call(source, target, replacement)
}

/**
 * @name 转换模板数据（仅限转换带方括号[...]的条码）
 *
 * @param {String} source 模板数据源
 * @param {Any} [replacement=String.fromCharCode(29)] 替换值 @see https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/String/replace
 *
 * @description
 * 示例: 转换博思得打印二维码的数据
 * export const replaceCode([01]06943718202035[10]202203141041[30]1[11]220301[17]240229) -> 0106943718202035\x1D10202203141041\x1D301\x1D11220301\x1D17240229
 *
 */
export const replaceCode = function (source, replacement = String.fromCharCode(29)) {
  if (isEmpty(source)) return source // 如果 source 为空则直接返回，等效为不处理
  return `${source}`.slice(1).replace('[', replacement).replace(']', '')
}

/**
 * @name 获取当月1号到当天的日期段
 * @description
 * 例如：当天 2022年12月5日
 * getRangeDateByFirstToCur() -> ["2022-12-01", "2022-12-05"]
 */
export const getRangeDateByFirstToCur = function () {
  const d = new Date()
  const year = d.getFullYear()
  const month = d.getMonth() + 1
  const day = `${d.getDate()}`.padStart(2, '0')

  const start = `${year}-${month}-01`
  const end = `${year}-${month}-${day}`

  return [start, end]
}

/**
 * @name 获取两个数组的交集和非交集的
 * @description
 * 例如：source=[{id: 1, ...}, {id:2, ...}, ...] target=[{id:2, ...}, {id:3, ...}, ...]
 * 预期结果：
 * {
 *   sames: [{id:2, ...}],
 *   diffs: [{id: 3, ...}, ...]
 * }
 */
export const getIntersectionOfArray = function (source, target, key) {
  const sames = [] // 存储交集的结果
  const diffs = [] // 存储非交集的结果
  const sourceArr = []
  for (const sourceItem of source) {
    const sourceItemVal = getValueByPath(sourceItem, key) ?? getValueByPath(sourceItem, '_ID')
    if (sourceItemVal) sourceArr.push(sourceItemVal)
  }
  for (const targetItem of target) {
    const targetItemVal = getValueByPath(targetItem, key) ?? getValueByPath(targetItem, '_ID')
    if (targetItemVal) {
      if (sourceArr.includes(targetItemVal)) {
        sames.push(targetItem)
      } else {
        diffs.push(targetItem)
      }
    }
  }

  return { sames, diffs }
}

/**
 * @name 生成指定两个数之间的随机数
 * @param min 最小的数
 * @param max 最大的数
 * @param {type=floor} 取数的类别，可能值: floor | ceil | round
 */
export const getRandomNum = function (min, max, type = 'floor') {
  return Math[type]?.(Math.random() * (max - min + 1) + min)
}

// 判断oldValue newValue是否相同
export function isEqual(oldValue, newValue) {
  return typeof oldValue === 'object' && typeof newValue === 'object'
    ? JSON.stringify(oldValue) === JSON.stringify(newValue)
    : oldValue === newValue
}
